export default __webpack_public_path__ + "static/media/calendar.6ef71097.gif";